module.exports = __webpack_public_path__ + "img/icon-family-values-bold.f7764c82.svg";